import React,{useEffect,useState} from 'react';
import Header from '../../components/common/Header';
import LoaderImg from '../../assets/images/loader.gif'
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import {useNavigate,useLocation, useParams} from 'react-router-dom';
import {getStudentTransactions, getSelectedDetail} from '../../actions/StudentAction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faDownload} from '@fortawesome/free-solid-svg-icons';

const MyTranSection = (props) => {
  const navigate = useNavigate();
  const useParam = useParams();
  const location=useLocation();
  const[transactions,setTransaction]=useState([])
  const[detail,setDetail]=useState(undefined)
  const [loading,setLoading] = useState(true)


useEffect(async()=>{
  sessionStorage.getItem('userDetail') ?  navigate(`/my-transactions/${useParam?.id !==undefined && useParam?.id} `) : navigate('/login');

   await getSelectedDetail(useParam.id!==undefined && useParam?.id).then((res) => {
        setLoading(true)
      if(res.status){
          setDetail(res.data);
      }
    });

    await getStudentTransactions(detail.id !==undefined && detail.id)
      .then((res) => {
        if(res.status){
          setLoading(false)
          setTransaction(res.data)
    }
    });

},[useParam?.id,detail?.id])

  return (
    <>
    {loading ? <div className="screenLoader text-center flex-wrap">
    <img src={LoaderImg} alt="Loading..." style={{width:'140px'}}/>
    </div>:
    <>
    <Header detail={detail}/>
       <section className="pt-5 pb-5 content-section">
          <div className="container">
            <PageBreadcrumbs profileDetailLink={detail} pagename="My Transaction" colFull/>

            <div className="row mt-4">
                <div className="col-lg-12">
                    <ul className="custom-responsive-table">
                        <li className="table-header">
                            <div className="col col-1">Transaction Id</div>
                            <div className="col col-2">Course Name</div>
                            <div className="col col-3">Amount</div>
                            <div className="col col-4">Transaction Date</div>
                            <div className="col col-4">Download</div>
                        </li>
                        {
                         
                          transactions!==null && transactions.length>0 && transactions.map((item, i) => (
                            <li className="table-row" key={i}>
                            <div className="col col-1" data-label="Transaction Id">{item.transaction_id}</div>
                            <div className="col col-2" data-label="Course Name">{item.course}</div>
                            <div className="col col-3" data-label="Amount">{item.local_paid_amount?item.local_paid_amount:item.paid_amount}</div>
                            <div className="col col-3" data-label="Transaction Date">{item.transaction_date}</div>

                            {item.payment_mode =="Offline" ?
                             item.acknowledgement_receipt !== '' && item.verification_status ==1 ? 
                              <div className="col col-3" data-label="Download Receipt"><a href={item.acknowledgement_receipt} target="_blank" download><FontAwesomeIcon  icon={faDownload}/> &nbsp; Receipt</a></div>
                            :<div className="col col-3" data-label="Download Receipt">{item.verification_status == 0 && 'Approval Pending'}{item.verification_status == 2 && 'Rejected'}</div>
                            :
                            item.acknowledgement_receipt !== '' ?
                            <div className="col col-3" data-label="Download Receipt"><a href={item.acknowledgement_receipt} target="_blank" download><FontAwesomeIcon  icon={faDownload}/> &nbsp; Receipt</a></div>
                            : <div className="col col-3" data-label="Download Receipt">Approval Pending</div>
                          }
                            
                        </li> 
                          ))
                        }
                        {transactions.length==0&&<li className="table-row text-center">
                        <div className="col col-12" >No records found</div>
                          
                          </li>}
                    </ul>

            </div>
            </div>

            </div>

        </section>
    </>
    }
    </>
  )
}

export default MyTranSection
